<template>
  <div class="switch">
    <slot name="left-label" />
    <v-switch
      v-model="vModelValue"
      :color="color"
      :dense="isMobile || small" 
      :label="label"
      class="switch"
      hide-details="auto"
      inset
      @change="change"
    ></v-switch>
    <slot name="right-label" />
  </div>
</template>

<script>
export default {
  name: "apio-switch",
  props: {
    label: {
      type: String,
      default: "",
    },
    small: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
    },
    value: {
      type: [Boolean, String],
    }
  },
  data() {
    return {
      vModelValue: this.value
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    vmodel: {
      get: function () {
        return this.vModelValue;
      },
      set: function (value) {
        this.vModelValue = value;
      },
    },
  },
  methods: {
    change() {
      this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
.switch {
  display: flex;
  align-items: center;
  background: transparent !important;

//   ::v-deep .v-input--switch__thumb {
//     height: 18px !important;
//     width: 18px !important;
//   }

//   ::v-deep .v-input--switch__thumb.theme--dark.primary--text {
//     height: 18px !important;
//     width: 18px !important;
//     background: white !important;
//   }

//   ::v-deep .v-input--switch__track {
//     height: 24px !important;
//     top: calc(50% - 13px) !important;
//     border: 1px solid var(--apio-cyan) !important;
//   }

//   ::v-deep .v-input--switch__track.theme--light,
//   ::v-deep .v-input--switch__track.theme--dark {
//     background-color: #1e88e5 !important;
//     opacity: 1 !important;
//   }

//   ::v-deep .v-input--selection-controls {
//     margin-top: 0 !important;
//     padding-top: 0 !important;

//     &__input {
//       margin-left: 12px !important;
//       margin-right: 6px !important;
//     }
//   }
// }


  ::v-deep
    .v-input.switch.v-input--hide-details.v-input--dense.theme--dark.v-input--selection-controls.v-input--switch.v-input--switch--inset,
  ::v-deep
    .v-input.switch.v-input--hide-details.v-input--dense.theme--light.v-input--selection-controls.v-input--switch.v-input--switch--inset {
    max-width: 58px;
    max-height: 22px;
  }
  
  ::v-deep
    div.v-input.switch.v-input--hide-details.v-input--dense.theme--light.v-input--selection-controls.v-input--switch.v-input--switch--inset
    > div
    > div
    > div
    > div.v-input--switch__track.theme--light {
    background: var(--apio-shade-5) !important;
    border: 1px solid var(--apio-shade-3) !important;
  }
  
  ::v-deep
    div.v-input.switch.v-input--hide-details.v-input--dense.theme--light.v-input--selection-controls.v-input--switch.v-input--switch--inset
    > div
    > div
    > div
    > div.v-input--switch__thumb.theme--light,
  ::v-deep
    div.v-input.switch.v-input--hide-details.v-input--is-label-active.v-input--is-dirty.v-input--dense.theme--light.v-input--selection-controls.v-input--switch.v-input--switch--inset
    > div
    > div
    > div
    > div.v-input--switch__thumb.theme--light {
    background: white;
    border: 1px solid var(--apio-shade-4) !important;
  }
  
  ::v-deep
    div.v-input.switch.v-input--hide-details.v-input--is-label-active.v-input--is-dirty.v-input--dense.theme--light.v-input--selection-controls.v-input--switch.v-input--switch--inset.primary--text
    > div
    > div
    > div
    > div.v-input--switch__track.theme--light.primary--text {
    background: var(--apio-purple) !important;
    border: 1px solid var(--apio-shade-3) !important;
    opacity: 1 !important;
  }
  
  ::v-deep
    div.v-input.switch.v-input--hide-details.v-input--dense.theme--light.v-input--selection-controls.v-input--switch.v-input--switch--inset
    > div
    > div
    > div
    > div.v-input--switch__track.theme--light {
    background: var(--apio-shade-4);
    opacity: 1;
  }
}

</style>